import { Suspense, lazy, useEffect, useRef, useState } from "react";
import { canRender3D } from "../../lib/deviceCapability";

const HeroScene = lazy(() => import("./HeroScene"));

function StaticGlow() {
  return (
    <div aria-hidden className="absolute inset-0 -z-10 bg-[#050813] overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 50% 55%, rgba(220,182,98,0.28), transparent 70%)," +
            "radial-gradient(ellipse 40% 40% at 75% 25%, rgba(92,124,250,0.22), transparent 70%)," +
            "radial-gradient(ellipse 40% 40% at 20% 30%, rgba(92,124,250,0.15), transparent 70%)"
        }}
      />
      <div
        className="absolute inset-0 opacity-40"
        style={{
          background:
            "linear-gradient(105deg, transparent 40%, rgba(243,230,204,0.08) 48%, transparent 56%)," +
            "linear-gradient(75deg, transparent 55%, rgba(243,230,204,0.06) 62%, transparent 70%)"
        }}
      />
    </div>
  );
}

export function HeroSceneLazyMount() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [shouldLoad, setShouldLoad] = useState(false);
  const [capable] = useState(() => canRender3D());

  useEffect(() => {
    if (!capable) return;
    const el = containerRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [capable]);

  return (
    <div ref={containerRef} className="absolute inset-0 -z-10 overflow-hidden">
      {!capable && <StaticGlow />}
      {capable && shouldLoad && (
        <Suspense fallback={<StaticGlow />}>
          <HeroScene />
        </Suspense>
      )}
    </div>
  );
}
